module.exports = __webpack_public_path__ + "static/media/note_taking.236f3874.svg";